// formatUtils.js
export const formatNumberWithCommas = (number) => {
  if (number === undefined || number === null) return "";
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const removeCommas = (number) => {
  return number.replace(/,/g, "");
};
